// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import Providers from '../search-data/providers';
import CreateProvider from '../app/create-provider';
import ProviderDetail from '../search-data/provider-detail';
import EditProvider from '../app/edit-provider';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Provider Detail',
                                component: ProviderDetail,
                            },
                        ],
                    },
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Providers',
                                component: Providers,
                            },
                        ],
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Create Provider',
                        component: CreateProvider,
                    },
                    {
                        type: 'tab',
                        name: 'Edit Provider',
                        component: EditProvider,
                    },
                ],
            },
        ],
    },
};

function DashboardProviders() {
    return <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="providers" />;
}

export default DashboardProviders;
